import { jsx, jsxs } from 'react/jsx-runtime';
import NoteStack from '../NoteStack/NoteStack.js';
import plur from 'plur';
import React__default from 'react';
import { styled, keyframes } from 'styled-components';
import { mediaMobile, mediaNotMobile } from '@fabric-app/ui/constants/styled-utils';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { useResponsive } from '@fabric-app/ui/hooks/useResponsive';

const NoteStackContentInner = styled.div.withConfig({
  displayName: "NotestackContent__NoteStackContentInner",
  componentId: "sc-1751dd64-0"
})([
  `display:flex;flex-direction:column;align-items:center;justify-content:center;gap:5rem;padding-top:4rem;`,
  `{padding-top:env(safe-area-inset-top);gap:2rem;justify-content:flex-end;height:100%;& > *{max-height:100%;}.note-stack-tilt-container{max-height:20dvh;}}&::before,&::after{content:'';flex:1;}`
], mediaMobile);
const StyledNoteStack = styled(NoteStack).withConfig({
  displayName: "NotestackContent__StyledNoteStack",
  componentId: "sc-1751dd64-1"
})([
  `height:50dvh;width:50dvh;max-height:260px;max-width:320px;`,
  `{height:180px;}`
], mediaMobile);
const inAnimationNotestack = keyframes([
  `from{opacity:0;scale:0.5;}to{opacity:1;scale:1;}`
]);
const outAnimationNotestack = keyframes([
  `from{opacity:1;scale:1;}to{opacity:0;scale:0.5;}`
]);
const NotestackContent = styled.div.withConfig({
  displayName: "NotestackContent",
  componentId: "sc-1751dd64-2"
})([
  `display:flex;flex-direction:column;position:fixed;left:2rem;width:calc(50% - 4rem);max-width:none;background:transparent;border:none;backdrop-filter:none;box-shadow:none;overflow:initial;height:100dvh;max-height:none;pointer-events:none;justify-content:center;`,
  `{--modal-transform-x:0%;}`,
  `{padding-top:env(safe-area-inset-top);height:40dvh;top:0;transform:none;left:0;width:100%;opacity:0;scale:0.5;justify-content:flex-end;[data-state='open'] &{animation:`,
  ` 0.2s ease-out forwards;animation-delay:0.2s;}[data-state='closed'] &{animation:`,
  ` 0.2s ease-out forwards;}}`
], mediaNotMobile, mediaMobile, inAnimationNotestack, outAnimationNotestack);
const SelectedInfo = styled.div.withConfig({
  displayName: "NotestackContent__SelectedInfo",
  componentId: "sc-1751dd64-3"
})([
  `background:rgba(`,
  `,0.3);height:2.75rem;padding:0 0.625rem;display:flex;justify-content:space-between;align-items:center;color:`,
  `;border-radius:0.875rem;font-weight:500;flex-shrink:0;`,
  `{height:2.25rem;font-size:0.875rem;padding:0 0.5rem;margin-top:1rem;}`
], cssVar["color-bg-primary-reverse-rgb"], cssVar["color-text-primary-reverse"], mediaMobile);
const MoveModalNoteStack = /* @__PURE__ */ React__default.forwardRef(function MoveModalNoteStackComp({ resources }, ref) {
  const { isMobileView } = useResponsive();
  const itemsCount = resources.length;
  return /* @__PURE__ */ jsx(NotestackContent, {
    "aria-describedby": "Preview of the files",
    ref,
    tabIndex: -1,
    children: /* @__PURE__ */ jsxs(NoteStackContentInner, {
      children: [
        /* @__PURE__ */ jsx(StyledNoteStack, {
          scale: isMobileView ? 0.6 : 0.9,
          verticalSpread: 0.5,
          horizontalSpread: 0.8,
          resources,
          noTilt: isMobileView
        }),
        /* @__PURE__ */ jsxs(SelectedInfo, {
          children: [
            "(",
            itemsCount,
            " ",
            plur("item", itemsCount),
            " selected)"
          ]
        })
      ]
    })
  });
});

export { MoveModalNoteStack };
//# sourceMappingURL=NotestackContent.js.map
